// extracted by mini-css-extract-plugin
export var closeButton = "_83-0";